export const state = {
  error: false,
  code: null
}

export const getters = {}

export const actions = {
  setError({ commit }, code) {
    commit('SET_ERROR', true)
    commit('SET_CODE', code)
  },
  clearError({ commit }) {
    commit('SET_ERROR', false)
    commit('SET_CODE', null)
  }
}

export const mutations = {
  SET_ERROR(state, error) {
    state.error = error
  },
  SET_CODE(state, code) {
    state.code = code
  }
}